import EmpresaService from '@/service/EmpresaService'

export default {
  namespaced: true,
  state: {
    links: [],
  },
  getters: {
    links(state) {
      return state.links
    },
  },
  mutations: {
    UPDATE_LINKS(state, links) {
      state.links = links
    },
  },
  actions: {
    async findAll({ commit }) {
      const dados = await EmpresaService.findLinks()
      const { loginFraction, loginValido, online, permitirEnvioDeclaracaoConteudo, senhaFraction, validaCepCorreio, ...links } = dados
      commit('UPDATE_LINKS', links)
      return links
    },
  },
}